<template lang="pug">
  div.h-100
    app-header(title='Checkout', :progressCurrent="slideIndex", :progressMax="slideCount", @backSignal="goBack")
    transition(name="down", mode="out-in")
      div.wizard-body.bg-alt.h-100.pt-3(v-if='showWizard')
        .container.h-100.pt-4
          b-carousel.h-100(id="carouselWizard", ref='carouselWizard', :no-touch="true", :interval="0", v-model="slideIndex")
            b-carousel-slide
              template(v-slot:img="")
                b-button(@click="onSubmit()", v-show="false", ref='submit0')
                .container.text-center
                  h2 ADDRESS
                  content-loader(:height="7", v-if='!address')
                  div#checkoutAddress(v-else="")
                    h4 {{ `${account.user.firstname} ${account.user.lastname}` }}
                    p {{ address.line_1 }}
                      br(v-if="address.line_2")
                      | {{ address.line_2 }}
                      br
                      | {{ address.city }}
                      br
                      | {{ address.zip }}
                      br
                      | {{ address.country}}
                    router-link.text-primary(:to="{name: 'AccountAddress', query: { sendmeback: true }}") EDIT
            b-carousel-slide
              template(v-slot:img="")
                b-button(@click="onSubmit()", v-show="false", ref='submit1')
                .container.text-center
                  h2 SHIPPING
                  span(v-if="alert.loading")
                    content-loader.w-50(:height="12")
                    p.mt-3 Just a second. Obtaining real-time shipping quotes...
                  div#checkoutShipping(v-else-if="quote")
                    h4 {{ `Shipping: ${formatRandsCents(shippingCost)}` }}
                    p {{ `Your order will be dispatched as ${shippingCount} shipment${shippingCount > 1 ? 's' : ''}` }}
            b-carousel-slide
              template(v-slot:img="")
                b-button(@click="onSubmit()", v-show="false", ref='submit2')
                .container.text-center
                  h2 SUMMARY
                  p This is what you will be paying
                  ul.list-unstyled
                      li.my-1
                        span.font-weight-bold Art
                        span.ml-1 {{ formatRandsCents(artCost) }}
                      li.my-1
                        span.font-weight-bold Shipping
                        span.ml-1 {{ formatRandsCents(shippingCost) }}
                      li.my-1
                        span.font-weight-bold Total
                        span.ml-1 {{ formatRandsCents(orderTotal) }}
                  div(v-if="orderType === 'rental'")
                    hr.my-5
                    b-form-group.center-xy
                      b-form-checkbox(v-model='aggreeRentalTerms', switch)
                        span(href="") I agree to the Wall Collective
                        a.text-primary.mx-2(:href="`${client_base_url}/legal`", target="_blank") Rental Terms & Conditions
                        span and have familiarised myself with all important info regarding the rental process, including guidelines on packaging and billing.
            b-carousel-slide
              template(v-slot:img="")
                .container.pt-5.text-center
                  b-spinner(type="grow")
                  p.pt-5 PLACING ORDER
    b-button#btn-bar(type='submit', :disabled="slideIndex == (slideCount - 1) || alert.loading", @click="$refs[`submit${slideIndex}`].click()")
      span(v-if="slideIndex >= (slideCount-2)") PLACE ORDER
      span(v-else="") NEXT
    form(v-if="pfParams", :action="payfast_url", ref='payfastForm')
      input(v-for="(value, name, index) in pfParams", :key="index", :name="name", type='hidden', :value="value")
</template>

<script>
// import Vue from 'vue';
import { mapState, mapGetters, mapMutations } from 'vuex';
import standardMix from '@/mixins/standardMix';
import { userService, apiService } from '@/services';
import router from '@/router';

export default {
  name: 'formWizard',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      aggreeRentalTerms: false,
      quote: null,
      checkoutItems: null,
      artCost: 0,
      shippingCost: 0,
      isRental: false,
      orderType: 'sale',
      pfParams: null,
      showWizard: false,
      slideIndex: 0,
      slideCount: 4,
      address: null,
      shippingMethod: null,
      shippingCount: null,
      shippingMethodFields: [
        { key: 'checkComp', label: '' },
        { key: 'carrier', label: 'Company' },
        { key: 'titleComp', label: 'Option' },
        { key: 'priceComp', label: 'Price' },
      ],
      fields: [
        { key: 'titleComp', label: 'Piece' },
        { key: 'compPrice', label: 'Price' },
        { key: 'compDiscount', label: 'Discount' },
        { key: 'compLineTotal', label: 'Total' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    ...mapState('cart', ['cart', 'rental']),
    // ...mapState('resource', ['shipping_methods']),
    ...mapGetters('cart', ['getCartTotal', 'checkCartForRentals']),
    orderTotal() {
      return parseFloat(this.artCost) + parseFloat(this.shippingCost);
    },
  },
  methods: {
    ...mapMutations('cart', ['addToCart', 'removeFromCart', 'emptyCart']),
    async onSubmit() {
      this.$refs.carouselWizard.next();
      if (this.slideIndex === 0) {
        try {
          this.loading();
          this.quote = await apiService.getQuote(this.checkoutItems, this.profileId, this.orderType);
          this.shippingCost = this.quote.shipping_cost;
          this.shippingCount = this.quote.shipments;
          this.clear();
        } catch (error) {
          this.clear();
          this.error('Could not calculate shipping');
          this.slideIndex = this.slideIndex - 1;
        }
      } else if (this.slideIndex === this.slideCount - 2) {
        if ((this.orderType === 'rental') && (!this.aggreeRentalTerms)) {
          this.error('Please agree to our Rental Terms & Conditions');
          this.goBack();
        } else {
          this.addOrder();
        }
      }
    },
    goBack() {
      if (this.slideIndex > 0) {
        this.$refs.carouselWizard.prev();
      }
    },
    async addOrder() {
      // Add order to system and get an internal payment ID
      try {
        this.busy();
        const res = await apiService.addOrder(this.orderTotal, this.quote.id);
        if (Math.floor(res.order_total) !== Math.floor(this.orderTotal)) {
          console.log(`From server: ${res.order_total} From client: ${this.orderTotal}`);
          this.error('Amount mismatch');
        } else {
          this.pfParams.m_payment_id = res.payment_id;
          this.pfParams.amount = res.order_total;
          this.emptyCart();
          if ((this.pfParams.m_payment_id) && (this.pfParams.amount)) {
            if (process.env.NODE_ENV === 'production') {
              // setTimeout to put this into event queue after component render
              // Create signature from parameters
              // const signature = this.makeSignature(this.pfParams);
              // this.pfParams.signature = signature;
              // console.log(this.$refs.payfastForm);
              setTimeout(() => {
                this.$refs.payfastForm.submit();
                // console.log(this.$refs.payfastForm);
              }, 10);
            } else {
              router.push('/order-ok');
              // this.slideIndex = this.slideIndex - 1;
            }
          } else {
            throw new Error('Not all values returned from order');
          }
        }
      } catch (error) {
        this.error(error);
        this.slideIndex = this.slideIndex - 1;
      }
    },
  },
  async created() {
    // this.slideIndex = 0;
    this.orderType = this.$route.params.type;
    this.isRental = this.$route.params.type === 'rental';
    this.checkoutItems = this.isRental ? [this.rental] : this.cart;
    this.address = await userService.getAddress(this.account.user.customer_id);
    this.artCost = this.isRental ? parseFloat(this.rental.price_rental) : this.getCartTotal;
    // Setup PayFast parameterfs
    this.pfParams = {
      merchant_id: process.env.VUE_APP_MERCHANT_ID,
      merchant_key: process.env.VUE_APP_MERCHANT_KEY,
      return_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-ok`,
      cancel_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-not-ok`,
      notify_url: `${process.env.ROOT_API}/payment/payfast/itn`,
      name_first: this.account.user.firstname,
      name_last: this.account.user.lastname,
      email_address: this.account.user.email,
      cell_number: this.account.user.phone,
      m_payment_id: '',
      amount: 0,
      // subscription_type: this.isRental ? 2 : 0,
      // recurring_amount: this.isRental ? this.rental.price_rental : 0,
      // frequency: 3,
      // cycles: 0,
      item_name: 'Wall Art Order',
      email_confirmation: '1',
      confirmation_address: 'dehanlouw@icloud.com',
      signature: '',
    };
    if (this.isRental) {
      this.pfParams.subscription_type = 2;
    }
  },
  mounted() {
    // Create animation effect
    setTimeout(() => { this.showWizard = true; }, 100);
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  z-index: 1000;
  background-color: white;
  // border-radius: 15px 15px 0 0;
  overflow-y: scroll;
}
  .carousel-indicators > li {
    background-color: blue !important;
  }
  .down-enter-active, .page-leave-active {
    transition: transform 0.5s;
  }
  .down-enter {
    transform: translateY(100%);
  }
  .logo {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Checkout.vue